export class Contacto {
    id:string;
    nombre:string;
    numero:string;
    email:string;
    
    _editando: boolean;
}